import React from 'react';

import { Route }         from 'react-router-dom';
import { Switch }        from "react-router";
import RestaurantView    from './RestaurantView/RestaurantView'
import RestaurantContext from './framework/RestaurantContext';

const ContextRestaurantView = (props) => <RestaurantContext {...props}><RestaurantView/></RestaurantContext>;
const AppRouter = () => {
	return (
		<Switch>
			<Route exact path="/restaurants/:restaurantId" component={ContextRestaurantView} />
		</Switch>
	);
};

export default AppRouter;



// WEBPACK FOOTER //
// /src/components/AppRouter.js